module.exports = __webpack_public_path__ + "static/media/assist-horiz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/CaseStudies/CaseStudiesQuestions/img/assist-horiz.svg
// module id = 575
// module chunks = 0